import React, { useState, useEffect } from 'react';

import { IconChevronRight, IconChevronLeft, IconX } from '@tabler/icons';
import { Container, Items, Image, IconWrapper, XWrapper } from './styles';

import propertyImg from '../../assets/images/image-example.png';
import { useHistory } from 'react-router-dom';

interface IImageModal {
  data: any[];
  isOpen: boolean;
  onClose: () => void;
}

const ImageModal: React.FC<IImageModal> = ({
  data,
  isOpen,
  onClose,
  ...rest
}) => {
  const [transform, setTransform] = useState(0);

  const history = useHistory();

  // hide scrollbar when is open
  useEffect(() => {
    const body = document.querySelector('body');

    if (body) {
      if (isOpen) {
        body.style.overflow = 'hidden';
      } else {
        body.style.overflow = 'auto';
      }
    }
  }, [isOpen]);

  // prevent navigating back when back button is pressed
  useEffect(() => {
    const unblock = history.block((location, action): any => {
      if (action === 'POP' && isOpen) {
        onClose();

        return false;
      }
      return true;
    });

    return () => {
      unblock();
    };
  }, [isOpen, history]);

  const handleNext = () => {
    const currentPage = transform / -100 + 1;

    if (currentPage < data.length) {
      setTransform(transform - 100);
    } else {
      setTransform(0);
    }
  };

  const handlePrevious = () => {
    const currentPage = transform / -100 + 1;

    if (currentPage !== 1) {
      setTransform(transform + 100);
    } else {
      setTransform((data.length - 1) * -100);
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Container {...rest}>
      <XWrapper onClick={onClose}>
        <IconX size={30} color="#fff" />
      </XWrapper>

      <Items>
        {data.length > 0 ? (
          data.map((image: any) => (
            <Image
              src={image.image_url}
              style={{ transform: `translateX(${transform}%)` }}
            />
          ))
        ) : (
          <Image src={propertyImg} />
        )}
      </Items>

      {data.length > 1 && (
        <>
          <IconWrapper onClick={handlePrevious} style={{ left: 20 }}>
            <IconChevronLeft size={30} color="#fff" />
          </IconWrapper>

          <IconWrapper onClick={handleNext} style={{ right: 20 }}>
            <IconChevronRight size={30} color="#fff" />
          </IconWrapper>
        </>
      )}
    </Container>
  );
};

export default ImageModal;
